export default {
	url: 'http://localhost:3000',
}